<template>
  <div ref="cardContainer" class="project-card min-w-fit" :class="{ deleted: isDeleted,blocked:isBlocked }" @click="openProject">
    <div v-if="isBlocked" class="flex absolute right-0">
      <svg width="142" height="32" viewBox="0 0 142 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="141" height="31" rx="5.5" fill="#94A3B8" />
        <rect x="0.5" y="0.5" width="141" height="31" rx="5.5" stroke="#E2E8F0" />
        <g clip-path="url(#clip0_3921_8204)">
          <path
            d="M18 23.5C22.1421 23.5 25.5 20.1421 25.5 16C25.5 11.8579 22.1421 8.5 18 8.5C13.8579 8.5 10.5 11.8579 10.5 16C10.5 20.1421 13.8579 23.5 18 23.5Z"
            stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M18 11.625V16H22.375" stroke="white" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </g>
        <path
          d="M32.8608 20V11.2727H36.1335C36.804 11.2727 37.3665 11.3977 37.821 11.6477C38.2784 11.8977 38.6236 12.2415 38.8565 12.679C39.0923 13.1136 39.2102 13.608 39.2102 14.1619C39.2102 14.7216 39.0923 15.2187 38.8565 15.6534C38.6207 16.0881 38.2727 16.4304 37.8125 16.6804C37.3523 16.9276 36.7855 17.0511 36.1122 17.0511H33.9432V15.7514H35.8991C36.2912 15.7514 36.6122 15.6832 36.8622 15.5469C37.1122 15.4105 37.2969 15.223 37.4162 14.9844C37.5384 14.7457 37.5994 14.4716 37.5994 14.1619C37.5994 13.8523 37.5384 13.5795 37.4162 13.3438C37.2969 13.108 37.1108 12.9247 36.858 12.794C36.608 12.6605 36.2855 12.5938 35.8906 12.5938H34.4418V20H32.8608ZM43.3192 20.1278C42.663 20.1278 42.0962 19.9915 41.619 19.7188C41.1445 19.4432 40.7795 19.054 40.5238 18.5511C40.2681 18.0455 40.1403 17.4503 40.1403 16.7656C40.1403 16.0923 40.2681 15.5014 40.5238 14.9929C40.7823 14.4815 41.1431 14.0838 41.6062 13.7997C42.0692 13.5128 42.6133 13.3693 43.2383 13.3693C43.6417 13.3693 44.0224 13.4347 44.3803 13.5653C44.7411 13.6932 45.0593 13.892 45.3349 14.1619C45.6133 14.4318 45.832 14.7756 45.9911 15.1932C46.1502 15.608 46.2298 16.1023 46.2298 16.6761V17.1491H40.8647V16.1094H44.7511C44.7482 15.8139 44.6843 15.5511 44.5593 15.321C44.4343 15.0881 44.2596 14.9048 44.0352 14.7713C43.8136 14.6378 43.555 14.571 43.2596 14.571C42.9442 14.571 42.6673 14.6477 42.4286 14.8011C42.19 14.9517 42.0039 15.1506 41.8704 15.3977C41.7397 15.642 41.6729 15.9105 41.6701 16.2031V17.1108C41.6701 17.4915 41.7397 17.8182 41.8789 18.0909C42.0181 18.3608 42.2127 18.5682 42.4627 18.7131C42.7127 18.8551 43.0053 18.9261 43.3406 18.9261C43.565 18.9261 43.7681 18.8949 43.9499 18.8324C44.1317 18.767 44.2894 18.6719 44.4229 18.5469C44.5565 18.4219 44.6573 18.267 44.7255 18.0824L46.1658 18.2443C46.0749 18.625 45.9016 18.9574 45.646 19.2415C45.3931 19.5227 45.0692 19.7415 44.6744 19.8977C44.2795 20.0511 43.8278 20.1278 43.3192 20.1278ZM49.0774 16.1648V20H47.5348V13.4545H49.0092V14.5668H49.0859C49.2365 14.2003 49.4766 13.9091 49.8061 13.6932C50.1385 13.4773 50.549 13.3693 51.0376 13.3693C51.4893 13.3693 51.8828 13.4659 52.218 13.6591C52.5561 13.8523 52.8175 14.1321 53.0021 14.4986C53.1896 14.8651 53.282 15.3097 53.2791 15.8324V20H51.7365V16.071C51.7365 15.6335 51.6229 15.2912 51.3956 15.044C51.1712 14.7969 50.8601 14.6733 50.4624 14.6733C50.1925 14.6733 49.9524 14.733 49.7422 14.8523C49.5348 14.9687 49.3714 15.1378 49.2521 15.3594C49.1357 15.581 49.0774 15.8494 49.0774 16.1648ZM57.2763 20.1151C56.7621 20.1151 56.3018 19.983 55.8956 19.7188C55.4893 19.4545 55.1683 19.071 54.9325 18.5682C54.6967 18.0653 54.5788 17.4545 54.5788 16.7358C54.5788 16.0085 54.6982 15.3949 54.9368 14.8949C55.1783 14.392 55.5036 14.0128 55.9126 13.7571C56.3217 13.4986 56.7777 13.3693 57.2805 13.3693C57.6641 13.3693 57.9794 13.4347 58.2266 13.5653C58.4737 13.6932 58.6697 13.848 58.8146 14.0298C58.9595 14.2088 59.0717 14.3778 59.1513 14.5369H59.2152V11.2727H60.7621V20H59.245V18.9688H59.1513C59.0717 19.1278 58.9567 19.2969 58.8061 19.4759C58.6555 19.652 58.4567 19.8026 58.2095 19.9276C57.9624 20.0526 57.6513 20.1151 57.2763 20.1151ZM57.7067 18.8494C58.0334 18.8494 58.3118 18.7614 58.5419 18.5852C58.772 18.4062 58.9467 18.1577 59.0661 17.8395C59.1854 17.5213 59.245 17.1506 59.245 16.7273C59.245 16.304 59.1854 15.9361 59.0661 15.6236C58.9496 15.3111 58.7763 15.0682 58.5462 14.8949C58.3189 14.7216 58.0391 14.6349 57.7067 14.6349C57.3629 14.6349 57.076 14.7244 56.8459 14.9034C56.6158 15.0824 56.4425 15.3295 56.326 15.6449C56.2095 15.9602 56.1513 16.321 56.1513 16.7273C56.1513 17.1364 56.2095 17.5014 56.326 17.8224C56.4453 18.1406 56.62 18.392 56.8501 18.5767C57.0831 18.7585 57.3686 18.8494 57.7067 18.8494ZM62.4059 20V13.4545H63.9485V20H62.4059ZM63.1815 12.5256C62.9371 12.5256 62.7269 12.4446 62.5508 12.2827C62.3746 12.1179 62.2866 11.9205 62.2866 11.6903C62.2866 11.4574 62.3746 11.2599 62.5508 11.098C62.7269 10.9332 62.9371 10.8509 63.1815 10.8509C63.4286 10.8509 63.6388 10.9332 63.8121 11.098C63.9883 11.2599 64.0763 11.4574 64.0763 11.6903C64.0763 11.9205 63.9883 12.1179 63.8121 12.2827C63.6388 12.4446 63.4286 12.5256 63.1815 12.5256ZM67.0774 16.1648V20H65.5348V13.4545H67.0092V14.5668H67.0859C67.2365 14.2003 67.4766 13.9091 67.8061 13.6932C68.1385 13.4773 68.549 13.3693 69.0376 13.3693C69.4893 13.3693 69.8828 13.4659 70.218 13.6591C70.5561 13.8523 70.8175 14.1321 71.0021 14.4986C71.1896 14.8651 71.282 15.3097 71.2791 15.8324V20H69.7365V16.071C69.7365 15.6335 69.6229 15.2912 69.3956 15.044C69.1712 14.7969 68.8601 14.6733 68.4624 14.6733C68.1925 14.6733 67.9524 14.733 67.7422 14.8523C67.5348 14.9687 67.3714 15.1378 67.2521 15.3594C67.1357 15.581 67.0774 15.8494 67.0774 16.1648ZM75.6939 22.5909C75.1399 22.5909 74.6641 22.5156 74.2663 22.3651C73.8686 22.2173 73.549 22.0185 73.3075 21.7685C73.0661 21.5185 72.8984 21.2415 72.8047 20.9375L74.1939 20.6009C74.2564 20.7287 74.3473 20.8551 74.4666 20.9801C74.5859 21.108 74.7464 21.2131 74.9482 21.2955C75.1527 21.3807 75.4098 21.4233 75.7195 21.4233C76.157 21.4233 76.5192 21.3168 76.8061 21.1037C77.093 20.8935 77.2365 20.5469 77.2365 20.0639V18.8239H77.1598C77.0803 18.983 76.9638 19.1463 76.8104 19.3139C76.6598 19.4815 76.4595 19.6222 76.2095 19.7358C75.9624 19.8494 75.6513 19.9062 75.2763 19.9062C74.7734 19.9062 74.3175 19.7884 73.9084 19.5526C73.5021 19.3139 73.1783 18.9588 72.9368 18.4872C72.6982 18.0128 72.5788 17.419 72.5788 16.706C72.5788 15.9872 72.6982 15.3807 72.9368 14.8864C73.1783 14.3892 73.5036 14.0128 73.9126 13.7571C74.3217 13.4986 74.7777 13.3693 75.2805 13.3693C75.6641 13.3693 75.9794 13.4347 76.2266 13.5653C76.4766 13.6932 76.6754 13.848 76.8232 14.0298C76.9709 14.2088 77.0831 14.3778 77.1598 14.5369H77.245V13.4545H78.7663V20.1065C78.7663 20.6662 78.6328 21.1293 78.3658 21.4957C78.0987 21.8622 77.7337 22.1364 77.2706 22.3182C76.8075 22.5 76.282 22.5909 75.6939 22.5909ZM75.7067 18.696C76.0334 18.696 76.3118 18.6165 76.5419 18.4574C76.772 18.2983 76.9467 18.0696 77.0661 17.7713C77.1854 17.473 77.245 17.1151 77.245 16.6974C77.245 16.2855 77.1854 15.9247 77.0661 15.6151C76.9496 15.3054 76.7763 15.0653 76.5462 14.8949C76.3189 14.7216 76.0391 14.6349 75.7067 14.6349C75.3629 14.6349 75.076 14.7244 74.8459 14.9034C74.6158 15.0824 74.4425 15.3281 74.326 15.6406C74.2095 15.9503 74.1513 16.3026 74.1513 16.6974C74.1513 17.098 74.2095 17.4489 74.326 17.75C74.4453 18.0483 74.62 18.2812 74.8501 18.4489C75.0831 18.6136 75.3686 18.696 75.7067 18.696ZM85.7528 20.1151C85.2386 20.1151 84.7784 19.983 84.3722 19.7188C83.9659 19.4545 83.6449 19.071 83.4091 18.5682C83.1733 18.0653 83.0554 17.4545 83.0554 16.7358C83.0554 16.0085 83.1747 15.3949 83.4134 14.8949C83.6548 14.392 83.9801 14.0128 84.3892 13.7571C84.7983 13.4986 85.2543 13.3693 85.7571 13.3693C86.1406 13.3693 86.456 13.4347 86.7031 13.5653C86.9503 13.6932 87.1463 13.848 87.2912 14.0298C87.4361 14.2088 87.5483 14.3778 87.6278 14.5369H87.6918V11.2727H89.2386V20H87.7216V18.9688H87.6278C87.5483 19.1278 87.4332 19.2969 87.2827 19.4759C87.1321 19.652 86.9332 19.8026 86.6861 19.9276C86.4389 20.0526 86.1278 20.1151 85.7528 20.1151ZM86.1832 18.8494C86.5099 18.8494 86.7884 18.7614 87.0185 18.5852C87.2486 18.4062 87.4233 18.1577 87.5426 17.8395C87.6619 17.5213 87.7216 17.1506 87.7216 16.7273C87.7216 16.304 87.6619 15.9361 87.5426 15.6236C87.4261 15.3111 87.2528 15.0682 87.0227 14.8949C86.7955 14.7216 86.5156 14.6349 86.1832 14.6349C85.8395 14.6349 85.5526 14.7244 85.3224 14.9034C85.0923 15.0824 84.919 15.3295 84.8026 15.6449C84.6861 15.9602 84.6278 16.321 84.6278 16.7273C84.6278 17.1364 84.6861 17.5014 84.8026 17.8224C84.9219 18.1406 85.0966 18.392 85.3267 18.5767C85.5597 18.7585 85.8452 18.8494 86.1832 18.8494ZM93.7802 20.1278C93.1239 20.1278 92.5572 19.9915 92.0799 19.7188C91.6055 19.4432 91.2404 19.054 90.9847 18.5511C90.729 18.0455 90.6012 17.4503 90.6012 16.7656C90.6012 16.0923 90.729 15.5014 90.9847 14.9929C91.2433 14.4815 91.604 14.0838 92.0671 13.7997C92.5302 13.5128 93.0742 13.3693 93.6992 13.3693C94.1026 13.3693 94.4833 13.4347 94.8413 13.5653C95.2021 13.6932 95.5202 13.892 95.7958 14.1619C96.0742 14.4318 96.293 14.7756 96.4521 15.1932C96.6112 15.608 96.6907 16.1023 96.6907 16.6761V17.1491H91.3256V16.1094H95.212C95.2092 15.8139 95.1452 15.5511 95.0202 15.321C94.8952 15.0881 94.7205 14.9048 94.4961 14.7713C94.2745 14.6378 94.016 14.571 93.7205 14.571C93.4052 14.571 93.1282 14.6477 92.8896 14.8011C92.6509 14.9517 92.4648 15.1506 92.3313 15.3977C92.2006 15.642 92.1339 15.9105 92.131 16.2031V17.1108C92.131 17.4915 92.2006 17.8182 92.3398 18.0909C92.479 18.3608 92.6737 18.5682 92.9237 18.7131C93.1737 18.8551 93.4663 18.9261 93.8015 18.9261C94.0259 18.9261 94.229 18.8949 94.4109 18.8324C94.5927 18.767 94.7504 18.6719 94.8839 18.5469C95.0174 18.4219 95.1183 18.267 95.1864 18.0824L96.6268 18.2443C96.5359 18.625 96.3626 18.9574 96.1069 19.2415C95.854 19.5227 95.5302 19.7415 95.1353 19.8977C94.7404 20.0511 94.2887 20.1278 93.7802 20.1278ZM99.5384 11.2727V20H97.9957V11.2727H99.5384ZM104.022 20.1278C103.366 20.1278 102.799 19.9915 102.322 19.7188C101.848 19.4432 101.483 19.054 101.227 18.5511C100.971 18.0455 100.843 17.4503 100.843 16.7656C100.843 16.0923 100.971 15.5014 101.227 14.9929C101.485 14.4815 101.846 14.0838 102.309 13.7997C102.772 13.5128 103.316 13.3693 103.941 13.3693C104.345 13.3693 104.725 13.4347 105.083 13.5653C105.444 13.6932 105.762 13.892 106.038 14.1619C106.316 14.4318 106.535 14.7756 106.694 15.1932C106.853 15.608 106.933 16.1023 106.933 16.6761V17.1491H101.568V16.1094H105.454C105.451 15.8139 105.387 15.5511 105.262 15.321C105.137 15.0881 104.963 14.9048 104.738 14.7713C104.517 14.6378 104.258 14.571 103.963 14.571C103.647 14.571 103.37 14.6477 103.132 14.8011C102.893 14.9517 102.707 15.1506 102.574 15.3977C102.443 15.642 102.376 15.9105 102.373 16.2031V17.1108C102.373 17.4915 102.443 17.8182 102.582 18.0909C102.721 18.3608 102.916 18.5682 103.166 18.7131C103.416 18.8551 103.708 18.9261 104.044 18.9261C104.268 18.9261 104.471 18.8949 104.653 18.8324C104.835 18.767 104.993 18.6719 105.126 18.5469C105.26 18.4219 105.36 18.267 105.429 18.0824L106.869 18.2443C106.778 18.625 106.605 18.9574 106.349 19.2415C106.096 19.5227 105.772 19.7415 105.377 19.8977C104.983 20.0511 104.531 20.1278 104.022 20.1278ZM111.506 13.4545V14.6477H107.744V13.4545H111.506ZM108.673 11.8864H110.215V18.0312C110.215 18.2386 110.246 18.3977 110.309 18.5085C110.374 18.6165 110.46 18.6903 110.565 18.7301C110.67 18.7699 110.786 18.7898 110.914 18.7898C111.011 18.7898 111.099 18.7827 111.178 18.7685C111.261 18.7543 111.323 18.7415 111.366 18.7301L111.626 19.9361C111.543 19.9645 111.425 19.9957 111.272 20.0298C111.121 20.0639 110.937 20.0838 110.718 20.0895C110.332 20.1009 109.984 20.0426 109.674 19.9148C109.364 19.7841 109.119 19.5824 108.937 19.3097C108.758 19.0369 108.67 18.696 108.673 18.2869V11.8864ZM112.797 20V13.4545H114.339V20H112.797ZM113.572 12.5256C113.328 12.5256 113.118 12.4446 112.941 12.2827C112.765 12.1179 112.677 11.9205 112.677 11.6903C112.677 11.4574 112.765 11.2599 112.941 11.098C113.118 10.9332 113.328 10.8509 113.572 10.8509C113.819 10.8509 114.029 10.9332 114.203 11.098C114.379 11.2599 114.467 11.4574 114.467 11.6903C114.467 11.9205 114.379 12.1179 114.203 12.2827C114.029 12.4446 113.819 12.5256 113.572 12.5256ZM118.781 20.1278C118.141 20.1278 117.587 19.9872 117.119 19.706C116.65 19.4247 116.286 19.0312 116.028 18.5256C115.772 18.0199 115.644 17.429 115.644 16.7528C115.644 16.0767 115.772 15.4844 116.028 14.9759C116.286 14.4673 116.65 14.0724 117.119 13.7912C117.587 13.5099 118.141 13.3693 118.781 13.3693C119.42 13.3693 119.974 13.5099 120.442 13.7912C120.911 14.0724 121.273 14.4673 121.529 14.9759C121.788 15.4844 121.917 16.0767 121.917 16.7528C121.917 17.429 121.788 18.0199 121.529 18.5256C121.273 19.0312 120.911 19.4247 120.442 19.706C119.974 19.9872 119.42 20.1278 118.781 20.1278ZM118.789 18.892C119.136 18.892 119.425 18.7969 119.658 18.6065C119.891 18.4134 120.065 18.1548 120.178 17.831C120.295 17.5071 120.353 17.1463 120.353 16.7486C120.353 16.348 120.295 15.9858 120.178 15.6619C120.065 15.3352 119.891 15.0753 119.658 14.8821C119.425 14.6889 119.136 14.5923 118.789 14.5923C118.434 14.5923 118.138 14.6889 117.903 14.8821C117.67 15.0753 117.495 15.3352 117.379 15.6619C117.265 15.9858 117.208 16.348 117.208 16.7486C117.208 17.1463 117.265 17.5071 117.379 17.831C117.495 18.1548 117.67 18.4134 117.903 18.6065C118.138 18.7969 118.434 18.892 118.789 18.892ZM124.769 16.1648V20H123.226V13.4545H124.701V14.5668H124.777C124.928 14.2003 125.168 13.9091 125.498 13.6932C125.83 13.4773 126.24 13.3693 126.729 13.3693C127.181 13.3693 127.574 13.4659 127.909 13.6591C128.248 13.8523 128.509 14.1321 128.694 14.4986C128.881 14.8651 128.973 15.3097 128.971 15.8324V20H127.428V16.071C127.428 15.6335 127.314 15.2912 127.087 15.044C126.863 14.7969 126.551 14.6733 126.154 14.6733C125.884 14.6733 125.644 14.733 125.434 14.8523C125.226 14.9687 125.063 15.1378 124.944 15.3594C124.827 15.581 124.769 15.8494 124.769 16.1648Z"
          fill="white" />
        <defs>
          <clipPath id="clip0_3921_8204">
            <rect width="20" height="20" fill="white" transform="translate(8 6)" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <div class="card-preview">
      <!-- <svg width="94" height="93" viewBox="0 0 94 93" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M40.86 68.383C38.1633 73.0758 35.7755 75.8628 34.9996 75.8628C34.4272 75.8628 33.9375 74.3488 33.9375 72.4732C33.9375 65.6185 38.216 55.3969 43.4737 45.4238C44.6262 47.4651 45.1761 50.4404 45.1761 54.493C45.1761 58.2517 43.5717 63.6525 40.86 68.383ZM60.4295 35.1569C56.2941 40.0756 54.1022 40.2338 52.3094 40.2338C51.1569 40.2338 48.852 39.6764 47.0894 38.8478C51.7897 30.6223 56.7988 23.1199 59.7667 18.5476C62.5838 14.2089 60.7685 11.7307 58.1773 11C57.3336 12.1901 49.3868 23.376 41.7714 36.8969C41.1688 36.6709 36.815 35.059 36.815 35.059C36.815 35.059 34.156 39.7141 37.636 41.3562C37.8017 41.439 38.0578 41.5671 38.4194 41.7328C38.5851 41.8081 38.7659 41.8985 38.9768 41.9889C33.1843 52.9187 28.3333 64.4661 28.3333 72.4732C28.3333 78.3636 31.4292 81 34.4949 81C36.4685 81 40.5285 79.7496 45.4473 71.3433C48.7917 65.6487 50.6975 59.3439 50.6975 54.493C50.6975 51.7662 49.9517 47.2843 48.8746 44.8588C49.8613 45.1451 51.3227 45.2053 51.5712 45.2129C55.2321 45.3786 58.3957 44.7232 61.9812 40.4221C63.6535 37.9364 61.9511 34.9309 60.4295 35.1494" fill="#CBD5E1"/>
      </svg> -->
      <img :src="projectCardImage" alt="Project Preview" class="w-full h-full object-cover" v-if="projectCardImage" />
      <div v-else class="w-full h-full flex items-center justify-center text-gray-500">
        No Preview Available
      </div>
    </div>
    <div class="card-info relative p-4">
      <div class="card-actions-container">
        <div class="info-name-container max-h-5 w-full">
            <div class="card-name-container">
              <span class="card-name text-base font-semibold text-gray-700 " :title="name" >
                {{ name }}
              </span>
            </div>
          <!-- <div class="public-icon" v-if="IsPublic">
            <PublicIcon />
          </div> -->
        </div>
        <FoliaContextMenu :userRole="userRole" :permissions="permissions" @menu-duplicate="$emit('duplicate', id)"
          @menu-reject="$emit('reject', id)" @menu-share="$emit('share', id)" @menu-rename="$emit('rename', id)"
          @menu-delete-project="$emit('remove', { id, name })" class="absolute -right-3" />
      </div>
      <div class="card-info-text flex flex-col ">
        <span class="card-summary text-xs text-gray-500 my-1"> {{ numFiles > 0 ? numFiles > 1 ? `${numFiles}
          Documents`: `${numFiles} Document` : 'No Document' }}</span>
        <!-- <div class="dot"></div> -->
          <span v-if="data?.updatedAt=== data.createdAt" class="card-summary text-xs text-gray-500 my-1">
            Created {{ lastEdited }}
          </span>
        <span v-else class="card-summary text-xs text-gray-500 my-1">{{ numFiles >= 1 || Date.parse(data.updatedAt) >
          Date.parse(data.createdAt) ? 'Last modified' : 'Created' }} {{ lastEdited }}</span>
        <div class="flex relative flex-row my-1 w-full">
          <div class="flex items-center">
            <div v-if="projectOwnerInfo" class="flex items-center">
              <div class="relative group">
                <div
                  class="w-6 h-6 flex items-center justify-center rounded-full bg-[#8CB3D5] text-white text-xs relative border border-gray-200 p-3">
                  {{ projectOwnerInfo.name ? projectOwnerInfo.name.slice(0, 2).toUpperCase() :
                    projectOwnerInfo.email.slice(0, 2).toUpperCase() }}
                </div>
                <div class="absolute top-full -left-4 mt-2 px-4 py-2
                   bg-gray-800 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 
                   transition-opacity whitespace-nowrap z-index-100">
                  {{ userRole === 'OWNER' ? 'You own this project' :
                    (projectOwnerInfo.name ? projectOwnerInfo.name.slice(0, 2).toUpperCase() :
                      projectOwnerInfo.email.slice(0, 2).toUpperCase())
                    + ' own this project' }}
                  <div
                    class="absolute bottom-full  left-4 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-b-[6px] border-b-gray-700">
                  </div>
                </div>
              </div>
              <svg class="m-2" width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="2" cy="2" r="2" fill="#CBD5E1" />
              </svg>

            </div>
            <div class="flex items-center">
              <div v-for="(collaborator, index) in collaborators.filter(e => e.role !== 'OWNER').slice(0, 3)"
                :key="collaborator.email"
                class="relative group p-3 w-6 h-6 flex items-center justify-center rounded-full bg-[#8CB3D5] text-white text-xs border-2 border-gray-200"
                :style="{ boxShadow: 'rgb(254 254 254) 0px 0px 0px 1px', marginLeft: index !== 0 ? '-8px' : '0' }">
                {{ collaborator.name ? collaborator.name.slice(0, 2).toUpperCase() : collaborator.email.slice(0,
                  2).toUpperCase() }}
                <div class="absolute top-full -left-4 mt-2 px-4 py-2
                   bg-gray-800 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 
                   transition-opacity whitespace-nowrap z-index-100">
                  {{ collaborator.name ? collaborator.name : collaborator.email }}
                  <div
                    class="absolute bottom-full left-4 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-b-[6px] border-b-gray-700">
                  </div>
                </div>
              </div>
              <div v-if="totalCollaboratorCount > 3" class="relative group">
                <div
                  class="w-6 h-6 flex items-center p-3 justify-center rounded-full bg-gray-200 text-gray-500 text-xs relative border border-white"
                  :style="{ marginLeft: '-8px' }">
                  +{{ totalCollaboratorCount - 3 }}
                </div>
                <div class="absolute top-full -left-4 mt-2 px-4 py-2
                   bg-gray-800 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 
                   transition-opacity whitespace-nowrap z-index-100">
                  {{ totalCollaboratorCount }} total users have access
                  <div
                    class="absolute bottom-full left-4 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-b-[6px] border-b-gray-700">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isPublic" class="absolute right-0">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 10H19" stroke="#94A3B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
                stroke="#94A3B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M13.75 10C13.75 16 10 19 10 19C10 19 6.25 16 6.25 10C6.25 4 10 1 10 1C10 1 13.75 4 13.75 10Z"
                stroke="#94A3B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, inject, onBeforeUnmount, onMounted, reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
import MoreActionsButton from "../../assets/vue-icons/more-actions-button.vue";
import { formattedTime } from "../common/utils.js";
import { SHARING_STATUS } from "../common/constants.js";
import AvatarStack from "../common/AvatarStack.vue";
import PublicIcon from "../../assets/vue-icons/public-icon.vue";
import FoliaContextMenu from "../common/FoliaContextMenu.vue";
import { BROADCAST_MESSAGE } from "../../core/constants.js";
import Folia_Drag_N_Drop from "../common/folia-drag-n-drop.js";
import projectCardImage from "../../assets/images/projectCardImage.svg";
export default {
  name: "ProjectCard",
  components: {
    MoreActionsButton,
    PublicIcon,
    AvatarStack,
    FoliaContextMenu,
  },
  props: {
    data: Object,
  },
  setup(props) {
    const router = useRouter();
    const $fetch = inject('$fetch');
    const isActionMenuShown = ref(false);
    const cardContainer = ref(null);
    const folia_Drag_N_Drop = new Folia_Drag_N_Drop();

    const id = computed(() => {
      return props.data.id;
    });
    const userRole = computed(() => {
      return props.data.userRole
    })
    const isPublic = computed(() => {
      return props.data.publicStatus === SHARING_STATUS.PUBLIC
    })
    const permissions = computed(() => {
      return props.data.permissions;
    })
    const name = computed(() => {
      return props.data.name;
    });
    const isBlocked = computed(() => {
      return props.data.isBlocked;
    });
    const numFiles = computed(() => {
      return props.data.totalDocuments;
    });
    const totalCollaboratorCount = computed(() => {
      return props.data.totalCollaboratorCount;
    });
    const collaborators = computed(() => {
      return props.data?.topCollaborators?.map(e => {
        return {
          name: e.user?.name,
          email: e.user?.email,
          role: e.collaboratorRole
        }
      }) || [];
    });
    const projectOwnerInfo = computed(() => {
      const { name = 'GUEST', email, } = props.data.ownerProfile;
      return { name, email };
    });
    const sharedLabel = computed(() => {
      return props.data.publicStatus.toLowerCase();
    });
    const lastEdited = computed(() => {
      if (Date.parse(props.data.updatedAt) > Date.parse(props.data.createdAt)) {
        return formattedTime(props.data.updatedAt)
      }
      return formattedTime(props.data.createdAt)
    });
    const isFavorite = computed(() => {
      return Math.round(Math.random() * 10000) % 3 === 0;
    });
    const isDeleted = computed(() => {
      return Boolean(props.data.deleted);
    });

    onMounted(() => {
      const { id, name, userRole } = props.data;
      folia_Drag_N_Drop.attach(cardContainer.value, id, name, userRole);
      $fetch.on(BROADCAST_MESSAGE.PROJECT_UPDATED, projectUpdated);
    })
    onBeforeUnmount(() => {
      folia_Drag_N_Drop.release();
      $fetch.off(BROADCAST_MESSAGE.PROJECT_UPDATED, projectUpdated);
    });
    watch(() => props.data, (newData, prevData) => {
      if (prevData.userRole !== newData.userRole) {
        folia_Drag_N_Drop.updateRole(newData.userRole);
      }
    });
    function projectUpdated(projectId) {
      if (projectId !== props.data.id) return;
      // fetchCollaborators();
    }
    // TODO: check if it's using
    function fetchCollaborators() {
      // $fetch.getProjectCollaborators(props.data.id)
      //   .then(({ collaborators, isOwner, publicStatus }) => {
      //   }).catch(console.error);
    }
    function openProject() {
      if (isDeleted.value) return;
      router.push("/p/" + props.data.id);
    }

    return {
      cardContainer, id, name, numFiles, sharedLabel, lastEdited, isFavorite, isDeleted,isBlocked,
      isActionMenuShown, collaborators, userRole, isPublic, permissions,
      openProject, projectCardImage, projectOwnerInfo, totalCollaboratorCount
    };
  },
};
</script>

<style lang="scss" scoped>
.project-card {
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  background: #FFFFFF;
  box-shadow: 0 1px 2px #e6e6e6;
  cursor: pointer;
  user-select: none;

  &:hover {
    box-shadow: 0 0 8px 4px #00000010;
  }

  .card-preview {
    border-radius: 12px 12px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #f1f5f9;
    height: 205px;
    width: 100%;
  }

  .card-info {
    // margin: 5px;
    // display: flex;
    // flex-direction: column;
    // align-items: flex-start;
    // justify-content: space-between;
    // padding: 0px 0px 0px 16px;
    // margin-top: 11px;

    .card-actions-container {
      display: flex;
      width: 100%;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      // text-align: center;
      .info-name-container {

        // display: flex;
        // flex-direction: row;
        // justify-content:flex-start;
        // position: relative;
        .card-name {
          // text-overflow: ellipsis;
          // overflow: hidden;
          // white-space: nowrap;

          position: absolute;
          max-width: 85%;
          white-space: nowrap;
          text-align:start;
          overflow: hidden;
          text-overflow: ellipsis;
          // color: #334155;
        }

        .public-icon {
          display: flex;
          align-items: center;
        }
      }
    }

    //.card-favorite-icon {
    //    position: absolute;
    //    right: 20px;
    //    color: silver;
    //}
    //.card-favorite-icon.selected {
    //    color: #f04e23;
    //}
    .card-info-text {
      // display: flex;
      // flex-direction: column;
      // color: #334155;
      // margin-top: -4px;

      // .dot {
      //   height: 4px;
      //   width: 4px;
      //   margin-left: 8px;
      //   margin-right: 8px;
      //   background-color: #CBD5E1;
      //   border-radius: 50%;
      //   display: inline-block;
      // }
      // .action-menu-container {
      //   margin-left: 10px;
      // }
    }

    .card-shared-list {
      width: 100%;
      height: 44px;
    }

    .card-summary {
      // color: #64748B;
      // font-weight: 400;
      // font-size: 12px;
      // line-height: 16px;
      // white-space: nowrap;
      // overflow: hidden;
    }
  }
}

.blocked{
  opacity: 0.7;
  pointer-events: none;
}
/* Tablet (landscape) ----------- */
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) {
  .project-card {
    // width: 335px;
    // max-width: 335px;
    // min-width: 335px;
    // height: 309px;

    .card-info {

      // width: 335px;
      .card-actions-container {
        .info-name-container {
          .card-name {
            max-width: 250px;
          }
        }
      }
    }
  }
}

.app-container {
  @media only screen and (max-width: 768px) {
    & .project-card {

      // max-width: 300px;
      // min-width: 300px;
      & .card-info {
        & .card-info-text {
          flex-direction: column;
          align-items: flex-start;
        }
      }
    }
  }
}
</style>
